import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DynamicObjectInterface } from '../type';
import type { AuthModel } from '../type/';

const initialState: AuthModel = {
  userInfo: undefined,
  token: '',
  loginError: false,
  errorMessage: '',
};

const authSlide = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setLogin(state, action: PayloadAction<DynamicObjectInterface>) {
      state.userInfo = action.payload.userInfo;
      state.token = action.payload.token;
      state.errorMessage = action.payload.errorMessage; // for future use
      state.loginError = action.payload.error;
    },

    clearLogin(state) {
      state.userInfo = undefined;
      state.token = '';
      state.errorMessage = '';
      state.loginError = false;
    },
  },
});

export default authSlide;
